import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

import * as fetchingStates from '../../constants/fetchingState';

let ConfirmModal = props => {
    const { title, message, fetching, onYes, onNo, show } = props;

    return (
        <Modal show={show}>
            <Modal.Header>
                {title &&
                    <Modal.Title>{title}</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
                {fetching === fetchingStates.INITIAL &&
                    <Alert bsStyle='warning'>{message}</Alert>}
                {fetching === fetchingStates.FETCHING &&
                    <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                {fetching === fetchingStates.FETCHED &&
                    <Alert bsStyle='success'>УСПЕХ!</Alert>}
                {fetching === fetchingStates.FAILED &&
                    <Alert bsStyle='danger'>'ОШИБКА!'</Alert>}
            </Modal.Body>

            {fetching === fetchingStates.INITIAL &&
                <Modal.Footer>
                    <Button bsStyle="success" type="button" onClick={onYes}>Да</Button>
                    <Button bsStyle="danger" type="button" onClick={onNo}>Нет</Button>
                </Modal.Footer>}
            {(fetching === fetchingStates.FETCHED || fetching === fetchingStates.FAILED) &&
                <Modal.Footer>
                    <Button type="button" onClick={onNo}>Закрыть</Button>
                </Modal.Footer>}
        </Modal>
    )
};

export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/components/common/ConfirmModal.jsx